<div class="onlineUsers {{color}}" [style]="{width: size+'px', height: size+'px'}"></div>